import React from 'react';
import ReactDOM from 'react-dom';
  /*
import './bootstrap.css';
import './Open-sans.css';
import registerServiceWorker from './registerServiceWorker';

// import './style.css';
import './marketPlace.css';
// import  'https://dev.primerates.com/wp-content/themes/pr-flat-responsive-pro-child/style.css';
// import './plmp-range-slider.css';
  */
import { getJsonV2, lenderOffersV2, sorts, ajaxEnpoint, toggleImage } from "./LoanOfferListV2";
import { Configuration } from "./Configuration";
import LoanCategoryContainerV2 from './LoanCategoryContainerV2';

const currentDevice = detectDevice() ? 'Mobile' : detectTab() ? 'Tab' : 'Web';
var loanAmount = getParam("amount");
var annualIncome = getParam("AI");
var zipCode = getParam("zipcode");
var creditScore = getParam("credit_score");
var lenderState = getParam("state");
var AFID = getParam("AFID");
var affiliateid = getParam("affiliateid");
var sortVersion = getParam("SV");
var versionLP = getParam("V");
var lenderParams = getParam("lendername");
var singleLender = getParam("singlelender");
var readOnly = getParam("readonly");

var loanAmountBC = getParam("loanAmount");
var loanPurpose = getParam("purpose");
var partnerid = getParam("partnerid");
var gclid = getParam("gclid");
var featured = getParam("featured");
var programid = getParam("programid");
var campaignid = getParam("campaignid");
var utmSource = getParam("utm_source");
var utmMedium = getParam("utm_medium");
var utmTerm = getParam("utm_term");
var utmCampaign = getParam("utm_campaign");
var utmContent = getParam("utm_content");
var dealerid = getParam("dealerId");
// var email = getParam("email");
var version = getParam("version");
var pl= getParam("pl");
var pcl= getParam("pcl");
var hei= getParam("hei");
var hel= getParam("hel");
var listInjection = null;
var rootIds = document.getElementsByClassName('lenderListShort');

init();
function init() {
    var interval = setInterval(function() {
        if(document.readyState === 'complete') {
            clearInterval(interval);
            if (Configuration.isLocalHost) {
                const lenderResult = lenderOffersV2;
                renderDocument(lenderResult.lenders.filter(recode => recode.active));
            }
            else {
                const promise = getJsonV2();
                promise.then(result => {
                    const lenderResult =result.lenderOffersV2;
                    renderDocument(lenderResult.lenders.filter(recode => recode.active));
                });
            }
        }
    });
}

function mobilecheck() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  function detectBrowser() {
    var browser = (function(agent){
        switch(true){
            case agent.indexOf("edge") > -1: return "edge";
            case agent.indexOf("opr") > -1 && !!window.opr: return "opera";
            case agent.indexOf("chrome") > -1 && !!window.chrome: return "chrome";
            case agent.indexOf("trident") > -1: return "ie";
            case agent.indexOf("firefox") > -1: return "firefox";
            case agent.indexOf("safari") > -1: return "safari";
            default: return "other";
        }
    })(window.navigator.userAgent.toLowerCase());

    return browser;
 }

 function getParam( name )
{
    name = name.replace(/[\\[]/,"\\[").replace(/[\]]/,"\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( window.location.search );
    if( results == null )
        return "";
    else {
        var decodedValue = decodeURIComponent(results[1]);
        return decodedValue.replace("%2520", " ").replace("%20", " ").replace("%2f", "").replaceAll("/", "");
    }
    
}
function detectDevice() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  
  function detectTab() {
    var check = false;
    check = ((function(a){if(/ipad|android.+\d safari|tablet/i.test(a))return true})(navigator.userAgent||navigator.vendor||window.opera))? true:false;
    return check;
  }
function renderDocument(lenderResult) {    
    //read only lander list mode (hide GET Started button)
    if(!window.readOnly && window.location.pathname.replaceAll('\/','') === 'acorn-personal-loans-ro' ){
        window.readOnly = true;
    }
    window.mobileDevice = mobilecheck();
    try {
       document.getElementById("wptime-plugin-preloader").style.display = "none"; //.style.display = "none";
    }
    catch(e) {

    }
    // ReactDOM.render(<LoanCategoryContainerV2 lenders={lenderResult} loanAmount={loanAmount} annualIncome={annualIncome} zipCode={zipCode}
    //     currentDevice={currentDevice} currentBrowser={detectBrowser()} creditScore={creditScore?creditScore:(window.credit_score?window.credit_score:'')} AFID={AFID}
    //     AffiliateId={affiliateid} SortVersion={sortVersion} listInjection={listInjection} Sorts={sorts}
    //     SID7={window.SID7 ? window.SID7 : ''} SID8={window.SID8 ? window.SID8 : ''} 
    //     SID9={window.SID9 ? window.SID9 : ''} SID10={window.SID10 ? window.SID10 : ''}
    //     cofigajaxEnpoint={ajaxEnpoint} versionLP={versionLP}
    //     loanAmountBC={loanAmountBC} loanPurposeBC= {loanPurpose} lenderState={lenderState?lenderState.toUpperCase():(window.state?window.state.toUpperCase():'')}
    //     partnerid={partnerid} gclid={gclid} featured={featured}
    //     programid={programid} campaignid={campaignid} utmSource={utmSource}
    //     utmMedium={utmMedium} utmTerm={utmTerm} utmCampaign={utmCampaign}
    //     utmContent={utmContent} dealerid={dealerid} version={version}
    //     lenderParams={lenderParams}
    //     pl={pl && pl.length > 0 ? pl : window.pl && window.pl.length > 0 ? window.pl : '0'}
    //     pcl={pcl && pcl.length > 0 ? pcl : window.pcl && window.pcl.length > 0 ? window.pcl : '0'}
    //     hei={hei && hei.length > 0 ? hei : window.hei && window.hei.length > 0 ? window.hei : '0'}
    //     hel={hel && hel.length > 0 ? hel : window.hel && window.hel.length > 0 ? window.hel : '0'}
    //     />,
    //     document.getElementById('root1'));
        let rootIds = document.getElementsByClassName('lenderListShort');
        Array.from(rootIds).forEach((curRoot) => {
            ReactDOM.render(<LoanCategoryContainerV2 lenders={lenderResult} loanAmount={loanAmount} annualIncome={annualIncome} zipCode={zipCode}
                currentDevice={currentDevice} currentBrowser={detectBrowser()} creditScore={creditScore?creditScore:(window[curRoot.id].credit_score?window[curRoot.id].credit_score:'')} AFID={AFID}
                AffiliateId={affiliateid} SortVersion={sortVersion} listInjection={listInjection} Sorts={sorts}
                SID7={window.SID7 ? window.SID7 : ''} SID8={window.SID8 ? window.SID8 : ''} 
                SID9={window.SID9 ? window.SID9 : ''} SID10={window.SID10 ? window.SID10 : ''}
                rootId= {curRoot.id} toggleImage={toggleImage}
                cofigajaxEnpoint={ajaxEnpoint} versionLP={versionLP}
                loanAmountBC={loanAmountBC} loanPurposeBC= {loanPurpose} lenderState={lenderState?lenderState.toUpperCase():(window[curRoot.id].state?window[curRoot.id].state.toUpperCase():'')}
                partnerid={partnerid} gclid={gclid} featured={featured}
                programid={programid} campaignid={campaignid} utmSource={utmSource}
                utmMedium={utmMedium} utmTerm={utmTerm} utmCampaign={utmCampaign}
                utmContent={utmContent} dealerid={dealerid} version={version}
                lenderParams={lenderParams} readOnly={(readOnly == "true" || window[curRoot.id].readOnly === true) ? true: false} 
                showSingleLender= {singleLender == "true" || (window[curRoot.id].singleLender == true ||  
                    ( (window[curRoot.id].lender && window[curRoot.id].lender !== '' && window[curRoot.id].lender.search(',') == -1) ||
                      (lenderParams != "" && lenderParams.search(',') == -1) ) )
                    ?true:false}
                pl={pl && pl.length > 0 ? pl : window[curRoot.id].pl && window[curRoot.id].pl.length > 0 ? window[curRoot.id].pl : '0'}
                pcl={pcl && pcl.length > 0 ? pcl : window[curRoot.id].pcl && window[curRoot.id].pcl.length > 0 ? window[curRoot.id].pcl : '0'}
                hei={hei && hei.length > 0 ? hei : window[curRoot.id].hei && window[curRoot.id].hei.length > 0 ? window[curRoot.id].hei : '0'}
                hel={hel && hel.length > 0 ? hel : window[curRoot.id].hel && window[curRoot.id].hel.length > 0 ? window[curRoot.id].hel : '0'}
                />,
                curRoot);
        });
        
        
      /* 
    registerServiceWorker();
      */
}



// WEBPACK FOOTER //
// ./src/index.js